class BgMobileLandHero {
    constructor(args = { sectionsContainer: document }) {
        this.sectionsContainer = args.sectionsContainer;
        this.sections = this.sectionsContainer.getElementsByClassName("land-hero-home-swiper");
        this.slides = this.sectionsContainer.getElementsByClassName("card-hero-home-slide");
        
        if (this.sections.length > 0) {
            this.init();
        }
    }

    init() {
        this.updateBackgrounds();
        window.addEventListener('resize', () => this.updateBackgrounds()); 
    }

    updateBackgrounds() {
        const isMobile = window.innerWidth <= 768;
        
        Array.from(this.slides).forEach(slide => {
            const bgMobile = slide.getAttribute("data-bgmobile");
            const bgDesktop = slide.getAttribute("data-bgdesktop");
            const degradate = 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), '
            
            if (isMobile) {
                //la primera es con degradado
                //slide.style.backgroundImage = `${degradate} url('${bgMobile}')`;
                slide.style.backgroundImage = `url('${bgMobile}')`;
                console.log('fondo mobile : ' + slide.style.backgroundImage)
            } else {
                //la primera es con degradado
                //slide.style.backgroundImage = `${degradate} url('${bgDesktop}')`;
                slide.style.backgroundImage = `url('${bgDesktop}')`;
                console.log('fondo desktop: ' + slide.style.backgroundImage)
            }
        });
    }
}

export default BgMobileLandHero;
